export default __webpack_public_path__ + "static/media/union3.99e40c6a.webp";